export default "skymp5-front/105ca7d3283ef324b4ed2135f1a2935b.jpg";